<template>
    <div class="line_box">
        <div class="line_box_header">
            <div class="header-icon-area" v-if="iconSrc">
                <img :src="require(`@/assets/${iconSrc}`)" alt="" />
            </div>
            <div class="header-title-area">{{ title }}</div>
        </div>
        <div class="line-box-body">
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {},
        iconSrc: {},
    },
};
</script>
<style lang="scss">
.line_box {
    width: 100%;
    border: 1px solid #534439;

    .line_box_header {
        width: 100%;
        height: 70px;
        display: flex;

        .header-icon-area {
            width: 70px;
            height: 70px;
            background: #534439;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .header-title-area {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            background: var(--orange);
            color: #fff;
            font-family: 'Pretendard', sans-serif;
            font-size: 22px;
            font-weight: 700;
            letter-spacing: -0.025em;
        }
    }

    .line-box-body {
        .content {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 40px 0;

            gap: 34px;

            .box {
                width: 330px;
                height: 76px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: var(--gray2);

                color: var(--black2);
                font-size: 18px;
                letter-spacing: -0.025em;
                font-family: 'Pretendard', sans-serif;

                &.active {
                    background: var(--red);
                    color: #fff;
                    box-shadow: 3px 3px 21px rgba(230, 28, 57, 0.5);
                }
            }
        }
    }
}
</style>
